import {editDateUsers, editUsernames} from '../service/editDateUsers';
import {getTimeObject, getTimesJsx} from "../service/getDuration";
import {GOT_USER_SESSIONS} from "../actions/data";

const defaultState={
    dateUsers:[],
    userSessions:[],
    total:0,
    lastPage: true,
    devices:[],
    event:undefined,
    metrika:undefined,
    usage : undefined
};
export const ERROR_EVENT_WORD = 'Exception';

const enrichMetrika=(metrika)=>{
    metrika.sessionsLength=getTimesJsx(metrika.sessions? metrika.playTime/metrika.sessions : 0);
    metrika.usersSession=metrika.users ? metrika.sessions/(metrika.users *metrika.days) : 0;
    metrika.playTime=getTimesJsx(metrika.playTime);
    return metrika;
};

const enrichUsage = (metrika) =>{
    for(let i=0; i< metrika.length; i++) {
        metrika[i].sessionsLength = getTimeObject(metrika[i].sessions ? metrika[i].playTime / metrika[i].sessions : 0);
        metrika[i].playTime = getTimeObject(metrika[i].playTime);
    }
    return metrika;
}

const countErrorsForEvents = (event) => {
    if (event.details) {
        let parsedEvent = JSON.parse(event.details);
        if (parsedEvent.condition && parsedEvent.condition.indexOf(ERROR_EVENT_WORD) != -1)
            return 1;
    }
    return 0;
}

const countErrors = (userSessions) => {
    if (typeof userSessions !== 'undefined') {
        let errorCounter = 0;
        userSessions.forEach((event) => errorCounter += (countErrorsForEvents(event) + countErrors(event.events)));
        return errorCounter;
    }
    return 0;
}

export default (state=defaultState, action)=>{
    //console.log(action);
    switch (action.type){
        case 'GOT_DATE_USERS':
            return {
                ...state,
                dateUsers: editDateUsers(action.dateUsers.items),
                total: action.dateUsers.total,
                lastPage: action.dateUsers.lastPage,
                devices: action.dateUsers.devices,
            };
        case GOT_USER_SESSIONS:
//            console.log(action.userSessions);
            return {
                ...state,
                userSessions:action.userSessions,
                errorCount: countErrors(action.userSessions),
                version : action.version,
                userInfo : editUsernames(action.userInfo)
            };
        case 'GOT_METRIKA':
            return {
                ...state,
                metrika:enrichMetrika(action.metrika)
            };
        case 'GOT_USAGE':
            console.log(action.usage)
            return {
                ...state,
                usage : enrichUsage(action.usage)
            };
        case 'VIEW_EVENT':
            return {
                ...state,
                event:action.event
            };
        case 'HIDE_EVENT':
            return {
                ...state,
                event:undefined
            };
        case 'GOT_EXCEPTIONS':
            console.log(action.exceptions)
            return {
                ...state,
                exceptions : action.exceptions,
                isLastPage: action.isLastPage
            };
        default:
            return state;
    }
};
